import React from 'react';
import {
  columnMultiSelect,
  columnNameLink,
  columnProject,
  columnDatasetLink,
  columnDataset,
  columnDataOwners,
  columnRequester,
  columnCreatedOn,
  columnCompletedOn,
  columnStatus,
  columnTools,
  columnTransferType,
  columnWorkspaceName,
  columnWorkspaceNameLink,
  columnReviewTools,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import TableSortedColumn from '@/components/table/TableSortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestsTableColumns = ({
  category,
  items,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnProject,
    columnDatasetLink,
    columnDataOwners,
    columnCreatedOn,
    columnCompletedOn,
    columnStatus,
    columnWorkspaceNameLink,
    columnTools,
  ],
}) => {
  const { orderBy, singleSorting } = Selectors.useRequestsTableColumns({ category });
  const onCheckBoxClick = Events.useToggleRequestsSelected(category);
  const onOrderByColumn = Events.useToggleRequestColumnOrderBy(category);

  return (
    <NameDescriptionColumns
      entity="request"
      category={category}
      onCheckBoxClick={onCheckBoxClick}
      onOrderByColumn={onOrderByColumn}
      orderBy={orderBy}
      singleSorting={singleSorting}
      items={items}
      columns={columns}
    >
      {hasColumn(columns, columnProject) && (<UnsortedColumn columnId={columnProject} />)}
      {hasColumn(columns, [columnDataset, columnDatasetLink]) && (
        <TableSortedColumn
          name={columnDataset}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting={singleSorting}
          sortable={category}
        />
      )}
      {hasColumn(columns, columnDataOwners) && (<UnsortedColumn columnId={columnDataOwners} />)}
      {hasColumn(columns, columnRequester) && (
        <TableSortedColumn
          name={columnRequester}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting={singleSorting}
          sortable={category}
        />
      )}
      {hasColumn(columns, columnTransferType) && (
        <TableSortedColumn
          name={columnTransferType}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting={singleSorting}
          sortable={category}
        />
      )}
      {hasColumn(columns, [columnWorkspaceName, columnWorkspaceNameLink]) && (
        <TableSortedColumn
          name={columnWorkspaceName}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting={singleSorting}
          sortable={category}
        />
      )}
      {hasColumn(columns, columnCreatedOn) && (
        <TableSortedColumn
          name={columnCreatedOn}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting={singleSorting}
          sortable={category}
        />
      )}
      {hasColumn(columns, columnCompletedOn) && (<UnsortedColumn columnId={columnCompletedOn} />)}
      {hasColumn(columns, columnStatus) && (<UnsortedColumn columnId={columnStatus} />)}
      {hasColumn(columns, columnReviewTools) && <UnsortedColumn />}
    </NameDescriptionColumns>
  );
};
export default RequestsTableColumns;
